import { createSelector } from 'reselect';
import { RootState } from '../../../../types';
import { EntityTypes } from '../../../../constants/entities';
import { IActionRegister, IHistoryItem, IRegisterReducer } from 'core/slices/register';
import { IEntityReducer } from '../../../reducers/entities';
import { selectHistory } from '../history';
import { ModuleType } from 'types/domain/module';
import { IStateReducer } from 'core/reducers/state';
import { ActionStatus } from 'types/domain/action';
import { Mode } from 'core/slices/session';

const entity = (state: RootState) => state.entity.present;
const register = (state: RootState) => state.register;
const state = (state: RootState) => state.state;
const history = selectHistory;
const mode = (state: RootState) => state.session.mode;

export const selectActionHistory = createSelector([entity, history, register, state, mode], parseActionHistory);

export function parseActionHistory(
  entity: IEntityReducer,
  history: IHistoryItem[],
  register: IRegisterReducer,
  state: IStateReducer,
  mode: Mode,
) {
  return history
    .filter(
      hist =>
        (hist.courseProgressId === state[EntityTypes.COURSE_PROGRESS] &&
          (mode === Mode.LEARNING ? hist.token === state[EntityTypes.TOKEN] : true)) ||
        (state[EntityTypes.SEARCH] && hist.searchId === state[EntityTypes.SEARCH]),
    )
    .reduce((prev, hist: IHistoryItem) => {
      return [
        ...prev,
        ...(hist.verificationRequestId
          ? [{ verificationRequest: entity[EntityTypes.VERIFICATION_REQUEST][hist.verificationRequestId] }]
          : hist.courseNodeId
          ? [{ courseNodeId: hist.courseNodeId }]
          : ![ModuleType.STANDARD, ModuleType.PDF].includes(register.attempts[hist.sessionAttemptId].type)
          ? [
              {
                moduleId: register.attempts[hist.sessionAttemptId].moduleId,
                sessionAttemptId: hist.sessionAttemptId,
              },
            ]
          : Object.values(register.attempts[hist.sessionAttemptId].actions)
              //filter out same action previously or not yet loaded actions
              .filter(
                a =>
                  !prev.some(ac => ac.id === a.actionId) &&
                  entity[EntityTypes.ACTION][a.actionId] &&
                  entity[EntityTypes.ACTION][a.actionId].status !== ActionStatus.DELETED,
              )
              .sort((a, b) => (a.created < b.created ? -1 : 1))
              .map((ar: IActionRegister) => {
                return {
                  actionId: ar.actionId,
                  moduleId: ar.moduleId,
                  sessionAttemptId: hist.sessionAttemptId,
                  actionRegisterId: ar.actionRegisterId,
                };
              })),
      ];
    }, []);
}
